import { useReducer, useState } from 'react'
import './App.css'
import NavItem from './Components/NavItem'
import PlainOrPrinted from './Components/Tabs/PlainOrPrinted';
import SizeAndQuantity from './Components/Tabs/SizeAndQuantity';
import Packaging from './Components/Tabs/Packaging';
import Summary from './Components/Tabs/Summary';
import { clone } from './helpers';

const tabs = [
  {
    id: 'plain_or_printed',
    label: 'Plain or Printed'
  },
  {
    id: 'size_and_quantity',
    label: 'Size and Quantity'
  },
  {
    id: 'packaging',
    label: 'Packaging'
  },
  {
    id: 'summary',
    label: 'Summary'
  }
];

function reducer(state, action) {
  let copy = clone(state);
  let keys = action.type.split('.');

  copy[keys[0]][keys[1]] = action.value;

  return copy;
}

function App({ data }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tab, setTab] = useState('plain_or_printed');
  const [state, dispatch] = useReducer(reducer, {
    'plain_or_printed': {
      'type': "plain"
    },
    'size_and_quantity': {
      'diameter': null,
      'height': null,
      'quantity': null
    },
    'packaging': {},
    'summary': {}
  });

  const addToBasket = async () => {
    setIsSubmitting(true);

    const type = state.plain_or_printed.type;

    const choice = data.size_and_quantity[`${type}_choices`].find((item) => {
        return item.diameter === state.size_and_quantity.diameter && item.height === state.size_and_quantity.height;
    });

    const totalPrice = choice[`${state.size_and_quantity.quantity}_unit_price`] * state.size_and_quantity.quantity;

    const response = await fetch('/wp-admin/admin-ajax.php?action=vtp_add_to_cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'text/html; charset=UTF-8',
      },
      body: JSON.stringify({
        'id': data.product.ID,
        'price': totalPrice,
        'options': {
          'type': state.plain_or_printed.type,
          'diameter': state.size_and_quantity.diameter,
          'height': state.size_and_quantity.height,
          'quantity': state.size_and_quantity.quantity,
        }
      })
    });
    
    const json = await response.json();
    console.log(json);

    // todo: if error

    window.location.href = "/cart";
  }

  console.log('data', data);
  console.log('state', state);

  return (
    <>
      <div className='nav'>
        {tabs.map(({ id, label }) => (
          <NavItem key={id} isActive={tab === id}>{label}</NavItem>
        ))}
      </div>

      {tab === 'plain_or_printed' && <PlainOrPrinted data={data} state={state} dispatch={dispatch} setTab={setTab} />}
      {tab === 'size_and_quantity' && <SizeAndQuantity data={data} state={state} dispatch={dispatch} setTab={setTab}  />}
      {tab === 'packaging' && <Packaging data={data} state={state} dispatch={dispatch} setTab={setTab}  />}
      {tab === 'summary' && <Summary data={data} state={state} dispatch={dispatch} setTab={setTab} addToBasket={addToBasket} isSubmitting={isSubmitting} />}
    </>
  )
}

export default App
